module.exports = __webpack_public_path__ + "img/gp_main03.d337e619.png";